import React, { ReactNode, useEffect } from 'react';

import './wasm_exec_go1-26.js';

const goWasm = new window.Go();
async function loadWasm(): Promise<void> {
  const result = await WebAssembly.instantiateStreaming(
    fetch('https://assets.futrli.com/predict/formulas/formula-validator_v1-6-2.wasm'),
    goWasm.importObject
  );
  goWasm.run(result.instance);
}

export const LoadWasm = (props: { children: ReactNode }) => {
  useEffect(() => {
    loadWasm();
  }, []);

  return <React.Fragment>{props.children}</React.Fragment>;
};
